import { render, staticRenderFns } from "./CustomResourceIDDialog.vue?vue&type=template&id=7afb2b04&scoped=true&"
import script from "./CustomResourceIDDialog.vue?vue&type=script&lang=js&"
export * from "./CustomResourceIDDialog.vue?vue&type=script&lang=js&"
import style0 from "./CustomResourceIDDialog.vue?vue&type=style&index=0&id=7afb2b04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afb2b04",
  null
  
)

export default component.exports